import { render, staticRenderFns } from "./dog-purchase-public-success.vue?vue&type=template&id=4700c31a&scoped=true&lang=pug"
import script from "./dog-purchase-public-success.js?vue&type=script&lang=js&external"
export * from "./dog-purchase-public-success.js?vue&type=script&lang=js&external"
import style0 from "./dog-purchase-public-success.vue?vue&type=style&index=0&id=4700c31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700c31a",
  null
  
)

export default component.exports